import type { DayOfWeek } from 'services/api';

export type TeacherWorkloadWorkDay = {
  dayOfWeek: DayOfWeek;
  unlimited?: boolean;
  startTime?: string;
  endTime?: string;
};

export enum EducationLevel {
  Noo = 'NOO',
  Ooo = 'OOO',
  Soo = 'SOO',
}

export type SubjectWorkload = {
  subjectId: number;
  subjectName: string;
  educationLevel: EducationLevel;
  workloadHours: number;
  educationalClassIds: number[];
};

export type PreferredRoom = {
  id: number;
  name: string;
  number: string;
};

export type TeacherWorkload = {
  id: number;
  code: string;
  rooms?: PreferredRoom[];
  qualifications: SubjectWorkload[];
  totalWorkload: number;
  workDays: TeacherWorkloadWorkDay[];
};

export type TeacherWorkloadsRequest = {
  page?: number;
  size?: number;
  sort?: string[];
  code?: string;
  preferredRoomIds?: number[];
  subjectIds?: number[];
  educationClassIds?: number[];
};

export type SubjectWorkloadRequest = {
  subjectId: number;
  workloadHours: number;
  educationalClassIds: number[];
};

export type CreateTeacherWorkloadBody = {
  code: string;
  preferredRoomIds?: number[];
  qualifications: SubjectWorkloadRequest[];
  workDays: TeacherWorkloadWorkDay[];
};

export type UpdateTeacherWorkloadBody = {
  id: number;
  qualifications: SubjectWorkloadRequest[];
  preferredRoomIds?: number[];
  code?: string;
  workDays: TeacherWorkloadWorkDay[];
};
